import { VintageHalf } from "../types/generated/graphql";

/**
 * Return translated half value with prefix
 * @param half
 * @param prefix
 * @returns string
 */
export const getVintageHalfText = (half?: VintageHalf | null, prefix = "") =>
  half ? `${prefix ? ` ${prefix} ` : ""}${half}` : "";
